import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignmentRoleComponent } from './assignment-role.component';
import { AssignmentRoleEditDialogComponent } from './assignment-role-edit-dialog/assignment-role-edit-dialog.component';
import { AssignmentRoleMatrixComponent } from './assignment-role-matrix/assignment-role-matrix.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatrixModule } from '../../../shared/matrix/matrix.module';
import { RoleToggleFilterModule } from '../../../shared/role-toggle-filter/role-toggle-filter.module';

@NgModule({
  declarations: [AssignmentRoleComponent, AssignmentRoleEditDialogComponent, AssignmentRoleMatrixComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
    MatrixModule,
    RoleToggleFilterModule,
  ],
  exports: [AssignmentRoleComponent],
})
export class AssignmentRoleModule {}
